import { render } from "./stage2.vue?vue&type=template&id=2bf3b52e&scoped=true"
import script from "./stage2.vue?vue&type=script&lang=js"
export * from "./stage2.vue?vue&type=script&lang=js"

import "./stage2.vue?vue&type=style&index=0&id=2bf3b52e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf3b52e"]])

export default __exports__